<template>
  <div v-if="accountCompliance"
    class="bg-white rounded-lg shadow p-4 w-full border border-gray-200 mb-3 flex flex-col lg:flex-row lg:items-center gap-4">

    <!-- Icono -->
    <div class="w-12 h-12 rounded-full bg-purple-500 flex items-center justify-center flex-shrink-0">
      <i class="bx bxs-rocket text-white text-2xl"></i>
    </div>

    <!-- Texto -->
    <div class="flex-1">
      <div class="flex items-center gap-2 mb-1">
        <span class="text-base font-bold text-gray-800">🎁 Ahorra en tu primer mes de Samii</span>
      </div>
      <p class="text-sm text-gray-600">
        Completa tu onboarding y recibe
        <span class="text-purple-700 font-bold">PRIMER MES PREMIUM</span>
        al precio del plan <span class="font-bold text-gray-800">BÁSICO</span>
      </p>
      <div class="flex items-center gap-1 mt-1 text-xs text-gray-400">
        <i class="bx bx-time-five"></i>
        <span>Tu prueba gratuita finaliza pronto</span>
      </div>
      <div class="flex items-center gap-2 mt-2 flex-wrap">
        <span class="px-3 py-1 rounded-full bg-purple-100 text-purple-700 text-xs font-semibold">0 días restantes</span>
        <span class="px-3 py-1 rounded-full bg-purple-100 text-purple-700 text-xs font-semibold">3 días restantes o
          menos</span>
        <span class="px-3 py-1 rounded-full bg-purple-100 text-purple-700 text-xs font-semibold">Último día</span>
      </div>
      <p class="text-xs text-gray-400 mt-1">Puedes activar tu beneficio en cualquier momento antes de que termine.</p>
    </div>

    <!-- Botón -->
    <div class="flex-shrink-0">
      <sa-button class="text-center" @click="$emit('activate')">
        Activar mi beneficio →
      </sa-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountComplianceBanner',
  computed: {
    accountCompliance() {
      return false;
      //return this.$store.state.account.accountCompliance;
    },
  },
};
</script>
